import React from 'react';
import { Wand2 } from 'lucide-react';
export function MagicLogo({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center gap-2.5 ${className}`} data-id="element-273">
      <div className="relative flex items-center justify-center w-9 h-9 rounded-xl bg-white/10 shadow-lg shadow-white/5 border border-white/10 overflow-hidden" data-id="element-274">
        <Wand2 className="w-5 h-5 text-gray-300 relative z-10" data-id="element-275" />
      </div>
      <span className="font-bold text-lg tracking-tight text-gray-200" data-id="element-276">
        Magic AI Builders
      </span>
    </div>;
}